module.exports = __webpack_public_path__ + "assets/adpoly-facility-pantries-bulk-upload-template.ae41123d.xlsx";